import { Info } from 'lucide-react'
import { type CSSProperties } from "react"
import "./payment.css";
export type PaymentAlertProps = {
  message?: string
  tone?: "error" | "info" | "warning" | "success"
  className?: string
  style?: CSSProperties
  showIcon?: boolean
}

export default function PaymentAlert({
  message = "Partial amount can’t be greater than the actual amount",
  tone = "error",
  className = "",
  style,
  showIcon = true,
}: PaymentAlertProps) {
  const validTones = new Set(["error", "info", "warning", "success"])
  const resolvedTone = validTones.has(tone) ? tone : "info"

  return (
    <div
      role="alert"
      aria-live="polite"
      className={`alert-inline alert-inline--${resolvedTone} ${className}`}
      style={style}
    >
      {showIcon && (
        <span className="alert-inline__icon-wrap" aria-hidden="true">
          <Info className="alert-inline__icon" />
        </span>
      )}
      <span className="alert-inline__text">{message}</span>
    </div>
  )
}
